import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, ErrorStateMatcher } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../../../../../app/core/_base/crud';
import { PackagesHttpService } from '../../../../../app/core/packages';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-edit-file-dialog',
  templateUrl: './edit-file-dialog.component.html',
  styleUrls: ['./edit-file-dialog.component.css']
})
export class EditFileDialogComponent extends MyErrorStateMatcher implements OnInit  {

	viewLoading = false;

	editForm: FormGroup;

	matcher = new ErrorStateMatcher();

	availableVersions = [];

	compVersions = [];

	types = [
		{text: 'UI', value: 'ui'},
		{text: 'Menu', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	modeSelect = new FormControl(null, [Validators.required]);
	desc = new FormControl('');

	modes = [
		{text: 'Engg Review', value: 'engg'},
		{text: 'Current', value: 'curr'},
		{text: 'Archived', value: 'arch'}
	];

	modeOptions: SelectOption[] = [
		{ value: 'engg', label: 'Engg Review' },
		{ value: 'curr', label: 'Current' },
		{ value: 'arch', label: 'Archived' }
	];

	availableColors = [
		{ name: 'v0.1.0' },
		{ name: 'v0.1.1' },
		{ name: 'v0.1.2' },
		{ name: 'v0.1.3' }
	];

	constructor(public dialogRef: MatDialogRef<EditFileDialogComponent>,
						 @Inject(MAT_DIALOG_DATA) public data: any,
  		  			 private http: PackagesHttpService) {
	  super();
	}

  ngOnInit() {
	//   console.log("Printing list",this.data);
	  this.modeSelect.setValue(this.data.file_mode);
	  this.desc.setValue(this.data.file_desc);

	  this.getInCompVersions();
	  if (this.data.file_comp) {
		this.compVersions = this.data.file_comp.split(',');
	  }

	//   setTimeout(() => {
	// 	  this.dialogRef.close({file: this.data});
	//   }, 50000);
  }

  getInCompVersions() {

	  let comps = '';
	  if (this.data.file_comp) {
		comps = this.data.file_comp.split(',');
	  }
	  this.http.getInCompVersions(comps)
	  .subscribe(incompVers => {
		this.availableVersions = incompVers;
	  });
  }

  	removeCompVersion(version) {
		this.availableVersions.push(version);
		this.compVersions.splice(this.compVersions.indexOf(version), 1);
	}

	addCompVersion(version) {
		this.availableVersions.splice(this.availableVersions.indexOf(version), 1);
		this.compVersions.push(version);
	}

	submitForm() {
		const modeValue = this.modeSelect.value || '';
		this.data.file_mode = modeValue;
		this.data.file_desc = this.desc.value;
		if (this.compVersions.length > 0) {
			this.data.file_comp = this.compVersions.join(',');
		} else {
			this.data.file_comp = null;
		}
		// console.log(this.data);
		this.http.cloudEdit(this.data)
		.subscribe(result => {
			this.dialogRef.close({success: true});
		}, error => {
			this.dialogRef.close({success: false});
		});
	}


}
